import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@kolmeo/ui-core";
import { Layout } from "react-native-reanimated";
import { createAnimatedComponent } from "./helpers";
const AnimatedBox = createAnimatedComponent(Box);
const LayoutAnimation = ({ duration = 200, children, ...props }) => {
    return (_jsx(AnimatedBox, { layout: Layout.duration(duration), ...props, children: children }));
};
export default LayoutAnimation;
